// let BASE_URL = 'https://gmtalk.sznews.com/jhxtapi/api.php?s=/';
let BASE_URL = process.env.NODE_ENV === "production" ? 'https://activity.sznews.com/front/luohu_education_question_front/index.php?s=' : '/api';
let apis = {
    // 获取题目列表
    getQuesList: BASE_URL + "/index/questions/list",
    // 获取单位列表
    getDepartmentList: BASE_URL + "/index/School/getSchoolList",
    // 提交注册信息
    addInfo: BASE_URL + "/index/user/addinfo",
    // 验证是否已注册
    getUserNameExisted: BASE_URL + "/index/user/getUserExisted",
    // 计算分数
    mark: BASE_URL + "/index/questions/mark",
    // 计算分数
    getMark: BASE_URL + "/index/questions/getmark",
    //获取用户信息
    getAppUserInfo: BASE_URL + "/index/User/getAppUserInfo",
    //获取当前用户的星星   
    getGloryCount: BASE_URL + "/index/Daka/getDakaNum",
    //是否打卡
    hasSignup: BASE_URL + "/index/Daka/isDaka",
    //打卡
    signup: BASE_URL + "/index/Daka/dakaAction",
    //获取学生信息
    getInfomation: BASE_URL + "/index/User/getUserInfo",
    //获取证书信息
    getCertInfo: BASE_URL + "/index/Finishdaka/getCertInfo",
};
export default apis;